import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectBoundingBoxIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 5V1H19V3.75H14V1H10V3.75H5V1H1V5H3.75V10H1V14H3.75V19H1V23H5V20.25H10V23H14V20.25H19V23H23V19H20.25V14H23V10H20.25V5H23ZM18.75 18.75H5.25V5.25H18.75V18.75Z"
        fill={color}
      />
      <path
        d="M13 10H11C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V11C14 10.4477 13.5523 10 13 10Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectBoundingBoxIcon.displayName = 'SelectBoundingBoxIcon';
